"use client"

import { usePathname } from "next/navigation"
import { AppShell } from "@/app/_components/chrome/app-shell"
import { LocalizedLink } from "@/shared/components/i18n/localized-link"
import { Footer } from "@/shared/components/layout/footer"
import { Logo } from "@/shared/components/logo"
import { stripLocaleFromPath } from "@/shared/lib/i18n/config"

export function MarketingShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const canonicalPathname = stripLocaleFromPath(pathname)
  const isSalesPage =
    canonicalPathname.startsWith("/pricing") ||
    canonicalPathname.startsWith("/subscription")

  if (isSalesPage) {
    return (
      <main className="min-h-screen bg-background text-foreground">
        <nav
          aria-label="Sales page navigation"
          className="fixed left-[max(1rem,env(safe-area-inset-left))] top-[max(1rem,env(safe-area-inset-top))] z-50"
        >
          <LocalizedLink
            href="/"
            aria-label="Pleasur.ai home"
            className="inline-flex rounded-md bg-background/70 px-2 py-1.5 backdrop-blur-sm transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
          >
            <Logo size="sm" responsive />
          </LocalizedLink>
        </nav>
        {children}
      </main>
    )
  }

  return (
    <AppShell>
      {children}
      <Footer />
    </AppShell>
  )
}
